import { styled } from '@linaria/react'

/**
 * Non-visual wrapper (FP-4333): stops button clicks (Play, How To Watch, Sign
 * In, Trailer, Favorite) from bubbling up to the banner's own "open details"
 * click, without affecting the button group's layout.
 */
export const ButtonsClickGuard = styled.div`
  display: contents;
`
